export default {
    state: {
    },
    mutations: {
    },
    actions: {
        async getDayPictureReportInfo({dispatch}, obj) {
            return await dispatch('apiQuery', {
                method:`/reports/day?date=${obj.date}`
            })
        }
    },
    getters: {
    }
}